import { Link } from 'react-router-dom';
import { Tag } from '@kula-ai/components';
import type { EntityChipData } from '../../../types';

interface EntityBlockProps {
  data: EntityChipData;
}

// Standalone entity chip block. The same chip shape ActionResultBlock renders
// inline for its `entities` list, promoted to a block so a backend payload of
// `type: "entity"` renders instead of falling through to nothing.
export const EntityBlock = ({ data }: EntityBlockProps) => {
  if (!data?.label) return null;
  const chip = (
    <Tag
      label={data.label}
      size="md"
      variant="outline"
      data-test-id={`entity-block-${data.id}`}
    />
  );
  if (data.href) {
    return (
      <Link to={data.href} className="inline-block w-fit">
        {chip}
      </Link>
    );
  }
  return chip;
};
